module.exports = __webpack_public_path__ + "static/img/zhinengxhejian_details.ccc69eaf.jpg";